module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_5.4765d5cf.png";